import { MethodInstall } from "../../utils";
import MessageBox from "./src/index.js";

export default {
  ...MethodInstall(MessageBox.alert, "Alert"),
  ...MethodInstall(MessageBox.confirm, "Confirm"),
  ...MethodInstall(MessageBox.prompt, "Prompt")
};
